import classNames from 'classnames';
import {useState} from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import DangerModal from '../../../../components/dangerModal';
import DotsLoading from '../../../../components/dotsLoading';
import Header from '../../../../components/header';
import {DeleteReason} from '../../../../models/utilities/removePostReason';
import {getInputGroupRoute} from '../../../../module/dashboard/category/utilities';
import ProductItem from '../../../../module/dashboard/products/productItem';
import ReportChart from '../../../../module/profile/reportChart';
import useRemoveAds from '../hooks/useRemoveAdd';
import styles from './ad-details.module.scss';
import {useAuth} from '../../../../context/authContext';
import {useDispatch} from 'react-redux';
import {
  addRegisterAdvertisement,
  resetFormData,
  resetOptionalFormData,
  resetRegisterAdvertisement,
} from '../../../../store/redux/advertisementRegisteration';
import {clearAllData} from '../../../../store/redux/addPictureAdvertisment';

const MyAdDetails = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(false);
  const {mutate, isLoading} = useRemoveAds();
  const dispatch = useDispatch();
  const {supplierProfile} = useAuth();
  if (!state) {
    return <Navigate to="/profile/my-ads" />;
  }
  const {post} = state;
  const handleDelete = (reason: DeleteReason) => {
    const payload: IRemovePostPayload = {
      guid: post?.guid,
      type: getInputGroupRoute[post?.input_group?.code],
      delete_reason: reason,
    };
    mutate(payload);
  };

  const routeToUpdate = (guid: string, route: string) => {
    switch (post?.input_group?.code) {
      case 17:
        if (post?.input?.code === 12) return '/post/edit/sellFarm/' + post.guid;
        return '/post/edit/rentFarm/' + post.guid;
      case 15:
        if (post?.input?.code === 11)
          return '/post/edit/machinery/' + post.guid;
        return '/post/edit/mechanizationService/' + post.guid;
      default:
        return '/post/edit/' + route + '/' + guid;
    }
  };

  return (
    <>
      <Header title="مدیریت آگهی" />
      <div className={styles['ad-details']}>
        <div className="px-3 mb-5">
          <ProductItem
            post={post}
            icon={post?.input_group.icon}
            inputGroupType={post?.input_group?.code}
          />

          <div className="pt-4">
            <span className="color-gray-1">آمار بازدید</span>
          </div>
          <div className="pt-3">
            {post && <ReportChart guid={post?.guid} />}
          </div>
          <div className="d-flex justify-content-start mt-5 align-items-center">
            <i className="icon-edit color-primary"></i>
            <span
              className="pe-2 color-gray-1"
              onClick={() => {
                navigate(
                  routeToUpdate(
                    post.guid,
                    getInputGroupRoute[post?.input_group?.code],
                  ),
                );
                dispatch(resetRegisterAdvertisement({}));
                dispatch(clearAllData());
                dispatch(resetOptionalFormData(''));
                dispatch(resetFormData(''));
                dispatch(
                  addRegisterAdvertisement({
                    ad_type: {
                      title: 'آگهی شخصی',
                      value: 'personal',
                    },
                  }),
                );
                dispatch(
                  addRegisterAdvertisement({
                    ad_type: {
                      title: 'آگهی فروشگاهی',
                      value: 'store',
                    },
                  }),
                );
              }}
            >
              ویرایش آگهی
            </span>
          </div>
          {supplierProfile?.store && (
            <div
              className="d-flex justify-content-start mt-4 align-items-center"
              onClick={() =>
                navigate(
                  '/shop/products/addShelf/' +
                    post?.guid +
                    '/' +
                    getInputGroupRoute[post?.input_group?.code],
                )
              }
            >
              <i className="icon-category-products color-primary"></i>
              <span className="pe-2 color-gray-1"> ویرایش قفسه بندی آگهی</span>
            </div>
          )}

          <div
            className="d-flex justify-content-start mt-4 align-items-center"
            onClick={() => setShow(true)}
          >
            <i className="icon-delete color-danger-red"></i>
            <span className="pe-2 color-gray-1">حذف آگهی</span>
          </div>
        </div>
        <DangerModal
          show={show}
          setShow={setShow}
          title="علت حذف آگهی را مشخص کنید"
        >
          <div className={classNames(styles['ad-details__reason'], 'px-3')}>
            <button
              onClick={() => handleDelete(DeleteReason.successful)}
              disabled={isLoading}
            >
              متقاضی پیدا شد
            </button>
            <button
              onClick={() => handleDelete(DeleteReason.unsuccessful)}
              disabled={isLoading}
            >
              متقاضی پیدا نشد
            </button>
            <button
              onClick={() => handleDelete(DeleteReason.canceled)}
              disabled={isLoading}
            >
              از انتشار آگهی منصرف شدم
            </button>
          </div>
          <div className="p-3 px-4">
            <button
              className="btn btn-danger bg-color-red-3 py-3 w-100"
              onClick={() => setShow(false)}
              disabled={isLoading}
            >
              {isLoading ? <DotsLoading /> : <>انصراف</>}
            </button>
          </div>
        </DangerModal>
      </div>
    </>
  );
};

export default MyAdDetails;
